import React from "react";

import { Form, Input, Select, Col, Row } from "antd";
import { states } from "../../../../../utils/Util";

function PaymentAddress({ type }) {
  return (
    <>
      {type === "vendor" ? (
        <></>
      ) : (
        <>
          <Form.Item name=" " label="Payee Name">
            <Input placeholder="" />
          </Form.Item>
        </>
      )}

      <Form.Item
        label={type === "vendor" ? "1099 Address" : "Payment Address"}
        name="address1099-1"
      >
        <Input placeholder="Address 1" />
      </Form.Item>

      <Form.Item label=" " name="address1099-2">
        <Input placeholder="Address 2" />
      </Form.Item>

      <Row>
        <Col span={10} style={{ marginLeft: "17%" }}>
          {" "}
          <Form.Item label=" " name="city1099">
            <Input placeholder="City" />
          </Form.Item>
        </Col>
        <Col flex={1}></Col>
        <Col flex={2}>
          <Form.Item label=" " name="state1099">
            <Select options={states} />
          </Form.Item>
        </Col>
        <Col flex={1}></Col>
        <Col flex={2}>
          <Form.Item label=" " name="zip1099">
            <Input placeholder="Zip" />
          </Form.Item>
        </Col>
      </Row>

      <Form.Item name="country1099" label=" ">
        <Input placeholder="Counntry" />
      </Form.Item>
    </>
  );
}

export default PaymentAddress;
